// -------------------- MAIN -----------------//
// ---- DASHBOARD PAGE

// COPY SVG INFO
export const m_d_copyImage = {
  name: 'copy',
  path: '/static/img/main_dashboard/copy.svg',
  desc: 'copyImage'
};
// TOOLTIP ICON
export const m_d_tooltipIcon = {
  name: 'tooltipIcon',
  path: '/static/img/main_dashboard/tooltipIcon.svg',
  desc: 'tooltipIcon'
};
// ECHOSYSTEM ORIGINAL TREE IMAGE IN THE LEARN MORE CARD
export const m_d_ecoTreeImage = {
  name: 'ecotree',
  path: '/static/img/main_dashboard/ecotree.svg',
  desc: 'ecoTreeImage'
};
// NOTIFICATION ICON GROUP
export const m_d_notiIcons = [
  {
    name: 'personal notification',
    path: '/static/img/main_dashboard/noti0.svg',
    desc: 'personal notification'
  },
  {
    name: 'global notification',
    path: '/static/img/main_dashboard/noti1.svg',
    desc: 'global notification'
  },
  {
    name: 'announcement notification',
    path: '/static/img/main_dashboard/noti2.svg',
    desc: 'announcement notification'
  },
  {
    name: 'notification content icon',
    path: '/static/img/main_dashboard/noti.svg',
    desc: 'notification content icon'
  }
];
// GROW TREE IMAGE GROUP
export const m_d_growTreeImage = [
  {
    name: 'growTree',
    path: '/static/img/main_dashboard/growtree9.svg',
    desc: 'growTreeImage'
  },
  {
    name: 'growTree',
    path: '/static/img/main_dashboard/growtree8.svg',
    desc: 'growTreeImage'
  },
  {
    name: 'growTree',
    path: '/static/img/main_dashboard/growtree7.svg',
    desc: 'growTreeImage'
  },
  {
    name: 'growTree',
    path: '/static/img/main_dashboard/growtree6.svg',
    desc: 'growTreeImage'
  },
  {
    name: 'growTree',
    path: '/static/img/main_dashboard/growtree5.svg',
    desc: 'growTreeImage'
  },
  {
    name: 'growTree',
    path: '/static/img/main_dashboard/growtree4.svg',
    desc: 'growTreeImage'
  },
  {
    name: 'growTree',
    path: '/static/img/main_dashboard/growtree3.svg',
    desc: 'growTreeImage'
  },
  {
    name: 'growTree',
    path: '/static/img/main_dashboard/growtree2.svg',
    desc: 'growTreeImage'
  },
  {
    name: 'growTree',
    path: '/static/img/main_dashboard/growtree1.svg',
    desc: 'growTreeImage'
  },
  {
    name: 'growTree',
    path: '/static/img/main_dashboard/growtree0.svg',
    desc: 'growTreeImage'
  }
];
export const m_d_treeRangeImage = {
  name: 'treeRange',
  path: '/static/img/main_dashboard/treerange.svg',
  desc: 'treeLangeImage'
};

// SmtCashMonitor
export const upImage = {
  name: 'up',
  path: '/static/img/main_dashboard/up.svg',
  desc: 'upImage'
};
export const key = {
  name: 'key',
  path: '/static/img/main_dashboard/key.svg',
  desc: 'keyImage'
};
export const nokey = {
  name: 'nokey',
  path: '/static/img/main_dashboard/nokey.svg',
  desc: 'nokeyImage'
};

// Left sidebar image 
export const userAvatar = {
  name: 'userAvatar',
  avatar: '/static/img/sidebar/profileImage.svg',
  desc: 'userAvatarImage'
};
export const profileMark = {
  name: 'profileMark',
  avatar: '/static/img/sidebar/profileMark.svg',
  desc: 'profileMarkImage'
};
export const publicUserInfo = {
  name: 'Mark77'
};
export const privateViewImage = {
  name: 'privateView',
  avatar: '/static/img/sidebar/privateProfileView.svg',
  desc: 'privateProfileView'
};
export const publicViewImage = {
  name: 'publicView',
  avatar: '/static/img/sidebar/publicProfileView.svg',
  desc: 'publicProfileView'
};
export const telegramView = {
  name: 'telegramView',
  avatar: '/static/img/sidebar/telegramView.svg',
  desc: 'telegramView'
};
export const markDown = {
  name: 'markDown',
  avatar: '/static/img/sidebar/markDown.svg',
  desc: 'markDown'
};
export const settingImage = {
  name: 'setting',
  avatar: '/static/img/sidebar/setting.svg',
  desc: 'settingImage'
};
export const nonProfileImage = {
  name: 'non-profile',
  avatar: '/static/img/sidebar/non-profile.png',
  desc: 'non profile image'
};

export const prevIcon = {
  name: 'prev',
  path: '/static/img/wealth_team/general/prev.svg',
  desc: 'prevIcon'
};